export const INITIALISE_PICTURE = 'BEAMLY/CCX/INITIALISE_PICTURE';
export const SET_PICTURE_HIGH_QUALITY_LOADING = 'BEAMLY/CCX/SET_PICTURE_HIGH_QUALITY_LOADING';
export const SET_PICTURE_HIGH_QUALITY_LOADED = 'BEAMLY/CCX/SET_PICTURE_HIGH_QUALITY_LOADED';
export const SET_PICTURE_LOW_QUALITY_LOADING = 'BEAMLY/CCX/SET_PICTURE_LOW_QUALITY_LOADING';
export const SET_PICTURE_LOW_QUALITY_LOADED = 'BEAMLY/CCX/SET_PICTURE_LOW_QUALITY_LOADED';
export const SET_PICTURE_BASE_QUALITY_ERROR = 'BEAMLY/CCX/SET_PICTURE_BASE_QUALITY_ERROR';
export const SET_LOW_QUALITY_RETRIES = 'BEAMLY/CCX/SET_LOW_QUALITY_RETRIES';
export const SET_STOP_LOW_QUALITY_RETRIES = 'BEAMLY/CCX/SET_STOP_LOW_QUALITY_RETRIES';
export const RESET_LOW_QUALITY_RETRIES = 'BEAMLY/CCX/RESET_LOW_QUALITY_RETRIES';
export const SET_HIGH_QUALITY_RETRIES = 'BEAMLY/CCX/SET_HIGH_QUALITY_RETRIES';
export const SET_STOP_HIGH_QUALITY_RETRIES = 'BEAMLY/CCX/SET_STOP_HIGH_QUALITY_RETRIES';
export const RESET_HIGH_QUALITY_RETRIES = 'BEAMLY/CCX/RESET_HIGH_QUALITY_RETRIES';
export const SET_ONLINE_STATUS = 'BEAMLY/CCX/SET_ONLINE_STATUS';

export const initialisePicture = id => ({
  type: INITIALISE_PICTURE,
  id,
});

export const setHighQualityLoading = (id, isLoading = true) => ({
  type: SET_PICTURE_HIGH_QUALITY_LOADING,
  id,
  isLoading,
});

export const setHighQualityLoaded = id => ({
  type: SET_PICTURE_HIGH_QUALITY_LOADED,
  id,
});

export const setLowQualityLoading = (id, isLoading = true) => ({
  type: SET_PICTURE_LOW_QUALITY_LOADING,
  id,
  isLoading,
});

export const setLowQualityLoaded = id => ({
  type: SET_PICTURE_LOW_QUALITY_LOADED,
  id,
});

export const setBaseQualityError = id => ({
  type: SET_PICTURE_BASE_QUALITY_ERROR,
  id,
});

export const setLowQualityRetries = (id, lowQualityRetries) => ({
  type: SET_LOW_QUALITY_RETRIES,
  id,
  lowQualityRetries,
});

export const setStopLowQualityRetries = (id, stopLowQualityRetries) => ({
  type: SET_STOP_LOW_QUALITY_RETRIES,
  id,
  stopLowQualityRetries,
});

export const resetLowQualityRetries = id => ({
  type: RESET_LOW_QUALITY_RETRIES,
  id,
});

export const setHighQualityRetries = (id, highQualityRetries) => ({
  type: SET_HIGH_QUALITY_RETRIES,
  id,
  highQualityRetries,
});

export const setStopHighQualityRetries = (id, stopHighQualityRetries) => ({
  type: SET_STOP_HIGH_QUALITY_RETRIES,
  id,
  stopHighQualityRetries,
});

export const setOnlineStatus = (id, online) => ({
  type: SET_ONLINE_STATUS,
  id,
  online,
});

export const resetHighQualityRetries = id => ({
  type: RESET_HIGH_QUALITY_RETRIES,
  id,
});
